import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { Input } from "components/bootstrap";
import StreamFilterFieldValue from "data-lake/components/StreamFilterFieldValue";
import AssetsFilterFieldValue from "data-lake/components/AssetsFilterFieldValue";
import InputFilterFieldValue from "data-lake/components/InputsFilterFieldValue";
const FIELDS_WITH_OPTIONS_MAP = {
  streams: "streams",
  associated_assets: "associated_assets",
  gl2_source_input: "gl2_source_input"
};
export const FIELDS_WITH_OPTIONS = Object.values(FIELDS_WITH_OPTIONS_MAP);
const FieldContainer = styled.div`
  flex-basis: 100%;
`;
function DataLakeFilterValueField({ field, fieldName, assetLabels, inputOptions }) {
  if ((field == null ? void 0 : field.name) === FIELDS_WITH_OPTIONS_MAP.streams) {
    return /* @__PURE__ */ React.createElement(StreamFilterFieldValue, { fieldName });
  }
  if ((field == null ? void 0 : field.name) === FIELDS_WITH_OPTIONS_MAP.associated_assets) {
    return /* @__PURE__ */ React.createElement(AssetsFilterFieldValue, { fieldName, assetLabels });
  }
  if ((field == null ? void 0 : field.name) === FIELDS_WITH_OPTIONS_MAP.gl2_source_input) {
    return /* @__PURE__ */ React.createElement(InputFilterFieldValue, { fieldName, inputOptions });
  }
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName, required: true }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(FieldContainer, null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "text",
      id: name,
      name,
      error,
      formGroupClassName: "",
      placeholder: "Field value",
      "aria-label": "Field value",
      required: true,
      onChange,
      value
    }
  )));
}
export default DataLakeFilterValueField;
